import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    filters: {
        ship: "",
        destination: "",
        onboard: "",
        type: "media",
        fulltext: "",
    },
    results: []
};

const gallerySlice = createSlice({
    name: 'gallery',
    initialState,
    reducers: {
        setShip: (state, { payload }) => {
            state.filters.ship = payload;
        },
        setDestination: (state, { payload }) => {
            state.filters.destination = payload;
        },
        setOnBoard: (state, { payload }) => {
            state.filters.onboard = payload;
        },
        setAssetType: (state, { payload }) => {
            state.filters.type = payload;
        },
        setFulltext: (state, { payload }) => {
            state.filters.fulltext = payload;
        },
        setResults: (state, { payload }) => {
            state.results = payload;
        },
        addResults: (state, { payload }) => {
            state.results.push(...payload);
        },
        clearShip: (state) => {
            state.filters.ship = "";
        },
        clearDestination: (state) => {
            state.filters.destination = "";
        },
        clearOnBoard: (state) => {
            state.filters.onboard = "";
        },
        clearAssetType: (state) => {
            state.filters.type = "media";
        },
        clearFilters: (state) => {
            state.filters.ship = "";
            state.filters.destination = "";
            state.filters.onboard = "";
            state.filters.type = "media";
            state.filters.fulltext = "";
        },
        clearResults: (state) => {
            state.results = [];
        }
    }
});

export const {
    setShip,
    setDestination,
    setOnBoard,
    setAssetType,
    setFulltext,
    setResults,
    addResults,
    clearShip,
    clearDestination,
    clearOnBoard,
    clearAssetType,
    clearFilters,
    clearResults
} = gallerySlice.actions;

export default gallerySlice.reducer;
